export default "__VITE_ASSET__CQcmI2Vt__"